import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import { useNavigate } from 'react-router-dom';
import '../colors.css';
import API_BASE_URL from '../api';

const PersonalityTest = () => {
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [expandedQuestion, setExpandedQuestion] = useState(null);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const getAuthToken = () => localStorage.getItem('stack_access_token');

  useEffect(() => {
    const token = getAuthToken();
    fetch(`${API_BASE_URL}/api/personality-test/questions`, {
      method: 'GET',
      headers: {
        'X-Stack-Access-Token': token,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch personality test questions.');
        }
        return response.json();
      })
      .then((data) => {
        if (data.length === 0) {
          setMessage('No personality test questions available.');
          return;
        }
        setQuestions(data);
      })
      .catch((error) => {
        console.error('Error fetching personality questions:', error);
        setMessage('Error fetching personality test questions.');
      });
  }, []);

  const handleAnswerChange = (questionId, answerText) => {
    setAnswers({
      ...answers,
      [questionId]: answerText,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const token = getAuthToken();

      //Submit Answers (This now also calculates personality)
      const response = await fetch(`${API_BASE_URL}/api/personality-test`, {
        method: 'POST',
        headers: {
          'X-Stack-Access-Token': token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ answers }),
      });

      if (!response.ok) {
        throw new Error('Failed to submit personality test answers.');
      }

      //Get the updated personality type from the response
      const resultData = await response.json();
      console.log('Updated Personality Type:', resultData.personalityType);

      setMessage('Successfully Submitted Personality Test!');

      //Redirect after successful submission
      setTimeout(() => {
        navigate('/processing-personality');
      }, 2000);
    } catch (error) {
      console.error('Error submitting personality test:', error);
      setMessage('Failed to submit and calculate personality test.');
    }
  };

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ backgroundColor: '#0D2329' }}
    >
      <Navbar />
      <div className="flex-1 flex justify-center items-center">
        <div
          className="w-full max-w-lg p-8 rounded-lg shadow-md"
          style={{ backgroundColor: '#05664f' }}
        >
          <h1
            className="text-4xl font-bold text-white text-center mb-6"
            style={{ fontFamily: 'Inter', textTransform: 'uppercase' }}
          >
            Personality Test
          </h1>

          {message && (
            <p className="text-sm text-green-200 text-center mb-4">{message}</p>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            {questions.slice(0, 6).map((q, index) => (
              <div key={index} className="text-white">
                <button
                  type="button"
                  className="w-full text-left p-3 bg-secondary rounded-md text-white font-medium"
                  onClick={() =>
                    setExpandedQuestion(
                      expandedQuestion === q.question_id ? null : q.question_id,
                    )
                  }
                >
                  {q.question_text}
                </button>

                {expandedQuestion === q.question_id && (
                  <div className="mt-2 bg-gray-800 p-3 rounded-md">
                    <label className="block text-sm font-medium">
                      Choose an answer:
                    </label>
                    <select
                      name={`question-${q.question_id}`}
                      value={answers[q.question_id] || ''}
                      onChange={(e) =>
                        handleAnswerChange(q.question_id, e.target.value)
                      }
                      className="mt-1 block w-full px-3 py-2 text-base border border-gray-300 text-black focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
                      required
                    >
                      <option value="">Select an option</option>
                      {q.options.map((opt) => (
                        <option key={opt.option_id} value={opt.option_text}>
                          {opt.option_text}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
            ))}

            <button
              type="submit"
              className="w-full px-4 py-2 border border-transparent rounded-lg shadow-md text-md font-medium text-white bg-gradient-to-r from-green-400 to-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Find Out What Personality Type You Are!
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PersonalityTest;
